export default __webpack_public_path__ + "static/media/puff-geosecma-support_f7d3bfcd2ca79c13a9e812ff71b71c6a.06675b34.png";